module.exports = __webpack_public_path__ + "img/appointment_title.0572cca9.png";